import { Component, OnInit, EventEmitter, ViewChild, Input, Output, SimpleChanges } from '@angular/core';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import {
    CatRutas
    , CatVencimientos
    , CatVencimientosInput
    , ObtenerUsuarioPorCargo
    , ObtenerUsuarioPorCargoInput
    , ConsultaLecturasInput
    , CatColonias
    , AguaBuscaCuentas
    , Aguas
    , CalculoCargosAguasInput,
    CatTipoPeriodos,
    AguaBuscaCuentasInput,
    ConsultaLecturas,
    ProximaAsignacionInput,
    AuxJasper,
    ParametroJasper,
    Privilegios,
}
    from "../../entidades/entidades";
import { CatRutasService } from "../../servicios/cat-rutas.service";
import { CatColoniasService } from "../../servicios/cat-colonias.service";
import { CalculoCargosAguasService } from "../../servicios/calculo-cargos-aguas.service";
import { VencimientosLecturaService } from "../../servicios/vencimientos-lectura.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { threadId } from 'worker_threads';
import { AguaBuscaCuentasService } from 'app/servicios/agua-busca-cuentas.service';
import { CatTipoPeriodosService } from 'app/servicios/cat-tipo-periodos.service';
import { ActivatedRoute } from '@angular/router';
import { ProximaAsignacionService } from '../../servicios/proxima-asignacion.service';
import { tick } from '@angular/core/testing';
import { ThrowStmt } from '@angular/compiler';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrivilegiosService } from 'app/servicios/privilegios.service';
declare var $: any;

@Component({
    selector: 'app-vencimientos-lectura',
    templateUrl: './vencimientos-lectura.component.html',
    styleUrls: ['./vencimientos-lectura.component.css']
})
export class VencimientosLecturaComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    buscaLecturas: FormGroup;
    public catRutas: CatRutas[] = [];
    public anios: any[] = [];
    public anioActual: CatVencimientos[] = [];
    public bimestre: CatVencimientos[] = [];
    public catUsuarios: ObtenerUsuarioPorCargo[] = [];
    public catColonias: CatColonias[] = [];
    public catColoniasSelec: CatColonias;
    public consultaLectura: ConsultaLecturasInput;
    public calculoCargosAguasInput: CalculoCargosAguasInput;
    public consulta :ConsultaLecturas;
    datosAguaCuenta = new AguaBuscaCuentas();
    datosAguas = new Aguas();
    contadorCargos: Number = 0;
    displayDomiciliacion: boolean = false;
    anio: number;
    periodo: number;

    public buscaLectura$ = new EventEmitter<ConsultaLecturasInput>();

    public auxJasper: AuxJasper;
    public auxJasperLecCalculadas: any[];
    display: boolean = false;
    vallecturas: boolean = false;
    progressBar = false;

    public ruta: CatRutas;
    public anioSeleccionado: CatVencimientos;
    public bimestreSeleccionado: CatVencimientos;
    public coloniaSeleccionado: CatColonias;
    public usuarioSeleccionado: ObtenerUsuarioPorCargo;
    public usuarios: ObtenerUsuarioPorCargoInput;
    public fechafac: Date = new Date();
    public fechavence: Date = new Date();
    public fechaemisi: Date = new Date();
    public avisoDirectivo: boolean = false;
    public tableWidget: any;
    public inhablitado:Boolean = false
    public observacionesMasivasCheckbox : boolean = false;
    public observacionMasivaTexto : string;
    proximaasignacion : ProximaAsignacionInput ;
    public domiciliacion$ = new EventEmitter<Boolean>();
    //public col:Array<CatColonias>;

    public cuenta: string;
    public cuentaRecibo: number;
    public muestraUsuario: boolean;
    public catTipoperiodo: CatTipoPeriodos[] = [];
    public PeriodoSeleccionado: CatTipoPeriodos;
    @Input() CargosAfectadosEmit: number = 0;
    @Input() muestraCuenta: boolean;
    @Input() muestraLecturista: boolean;
    @Input() muestraColonias: boolean;
    @Input() MuestraLimpiar: boolean;
    @Input() MustraPeriodoActual: boolean;
    @Input() MuestraReportRecepcion: boolean;
    @Input() muestraFechaFacturacion: boolean;
    @Input() muestraFechaVecimiento: boolean;
    @Input() muestraFechaEmision: boolean;
    @Input() muestraAvisoDirec: boolean;
    @Input() muestraImprimir: boolean;
    @Input() muestraCerrarRuta: boolean;
    @Input() Recalcular: boolean = false;
    @Input() Buscar: boolean = false;
    @Input("captura") captura: boolean = false;
    @Input("simulacion") simulacion: boolean = false;
    @Input("correciones") correciones: boolean = false;
    @Input("aguaBuscaCuentas") aguaBuscaCuentas: EventEmitter<AguaBuscaCuentas>;
    @Input() MuestraInpuntAnioPeriodo: boolean;
    @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;
    @Input() esEstadoCuentaMaisvo: boolean;
    muestraImpRuta: boolean = false;
    imprime : boolean = true;
    disabledCalcula: boolean = true;
    disabledImpRecepcion: boolean = true;
    disabledImpRecibos: boolean = true;
    disabledBotton: boolean = false;

    public catVencimientosLecturasInputAnio: CatVencimientosInput;
    public catVencimientosLecturasInputPeriodo: CatVencimientosInput;

    @Output("busquedaParametrosInput") busquedaParametrosInput: EventEmitter<ConsultaLecturasInput>;
    @Output("calcularOutput") calcularOutput: EventEmitter<ConsultaLecturasInput>;  // se usa para emitir evento en el boton calcular
    @Output("flagRecalcular") flagRecalcular: EventEmitter<boolean>;
    @Output() eliminaProgressBar = new EventEmitter();
    @Output()ImprimeRecepcionEmit: EventEmitter<ConsultaLecturasInput>;
    @Output("cerrarRutaEmit") cerrarRutaEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()GuardaValidado: EventEmitter<null>;
    @Output()ImprimeRecibosEmit: EventEmitter<ConsultaLecturasInput>;
    @Input() MuestraToogleReimprimir: boolean = false;
    currentRoute: string;
    public progressBar1 = false;
    public checkedReimprimir: boolean = false;
    public msjTooltip: string = "Imprimir Recibos";
    @Output() emiteProgressBar:  EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()emiteDesabledBotton: EventEmitter<boolean> = new EventEmitter<boolean>();
    clickReimprimir: boolean = false;
    permisoReimprimir: boolean = false;

    showBar() {
        this.progressBar1 = true;
    }
    showDialog() {

        this.display = true;
    }

    constructor
        (
            private catRutasService: CatRutasService,
            private CatColoniasService: CatColoniasService,
            private catUsuariosService: ObtenerUsuarioPorCargoService,
            private catTipoPeriodoService: CatTipoPeriodosService,
            private formBuilder: FormBuilder,
            private vencimientosLecturaService: VencimientosLecturaService,
            private aguaBuscaCuentasService: AguaBuscaCuentasService,
            private calculoCargosAguasService: CalculoCargosAguasService,
            private proximaAsignacionService: ProximaAsignacionService,
            private route: ActivatedRoute,
            private confirmationService: ConfirmationService,
            private messageService: MessageService,
            private privilegiosService: PrivilegiosService,
        ) {
        this.busquedaParametrosInput = new EventEmitter();
        this.calcularOutput = new EventEmitter();   // se usa para emitir evento en el boton calcular
        this.flagRecalcular = new EventEmitter();
        this.aguasOutput = new EventEmitter();
        this.aguaBuscaCuentas = new EventEmitter();
        this.ImprimeRecepcionEmit = new EventEmitter();
        this.GuardaValidado = new EventEmitter();
        this.ImprimeRecibosEmit = new EventEmitter();
    }

    async ngOnChanges() {
        if(this.CargosAfectadosEmit) this.contadorCargos = this.CargosAfectadosEmit;
    }

    async ngOnInit() {

        const tienePermisoReimprimir = await this.getPrivilegios();
        
        if(tienePermisoReimprimir) {
            this.permisoReimprimir = true;
        }else{this.permisoReimprimir = false;} 
        
      
        this.fechavence = new Date(this.fechafac);
        this.fechavence.setDate(this.fechavence.getDate() + 15);

        this.buscaLecturas = this.formBuilder.group({
            anioT: [undefined],
            ruta: [undefined],
            bimestre: [undefined],
            colonia: [undefined],
            cuenta: [undefined],
        });
        
        this.cerrarRutaEmit.emit(false);
        this.currentRoute = this.route.snapshot.url.map(segment => segment.path).join('/');

        await this.getCatRutas();
  
        if (this.muestraLecturista) this.getCatUsuarios();
        if (this.muestraColonias) this.getCatColonias();
    }

    onInput(cadena){    
         if(cadena != undefined){
            this.inhablitado = true
            let zona = new CatRutas()
                zona.id = 1
         }else{
            this.inhablitado = false
         }
      }
    
      onFechaFacturacionChange(event: any) {
        if (event) {
            this.fechavence = new Date(event);
            this.fechavence.setDate(this.fechavence.getDate() + 15);
        }
    }

    async getCatRutas() {

        try {
            /*let datoRetorno 
            debugger
            if(this.currentRoute === 'captura-lecturas'){ 
                // Acción especial para 'captura-lecturas''
                this.muestraImpRuta = true;
                datoRetorno = await this.catRutasService.getAllFiltradosEnProceso().toPromise() 
            }else if(this.currentRoute === 'estadocuentamasivo'  && (this.checkedReimprimir == false)){
                datoRetorno = await this.catRutasService.getAllFiltrados().toPromise()
            }else if(this.currentRoute === 'estadocuentamasivo' && (this.checkedReimprimir == true)){
                datoRetorno = await this.catRutasService.getRutasFiltradasCosumusosVigentes().toPromise()
            }else{
            await this.catRutasService.getAll().toPromise();
            };*/

            
            const datoRetorno = this.currentRoute === 'captura-lecturas' ? (this.muestraImpRuta = true, await this.catRutasService.getAllFiltradosEnProceso().toPromise()) // Acción especial para 'captura-lecturas''
            : (this.currentRoute === 'estadocuentamasivo'  && !this.checkedReimprimir) ? await this.catRutasService.getAllFiltrados().toPromise() 
            : (this.currentRoute === 'estadocuentamasivo' && this.checkedReimprimir) ? await this.catRutasService.getRutasFiltradasCosumusosVigentes().toPromise() : await this.catRutasService.getAll().toPromise();
            
            this.catRutas = datoRetorno;
            this.catRutas.unshift({ numRow: null, id: null, descripcion: 'SELECCIONA...', dato: "", fechaCorte: null });
        } catch (error) {
            console.log("error", error);
            if (error.response) throw { message: error.response.data };
            else throw error;
        
        } 
    }

    async getTipoPeriodo() {
        this.catTipoperiodo = []
        this.PeriodoSeleccionado = null;
        const datoRetorno = await this.catTipoPeriodoService.getAll().toPromise();
        const id_tipo_periodo = JSON.parse(this.ruta.dato)?.id_tipo_periodo;

        if(id_tipo_periodo){ // Si ya esta definido que tipo de periodo le corresonde a una ruta, solo se carga ese tipo de periodo, en otro caso, se cargan todos.
            this.catTipoperiodo =  datoRetorno.filter(x => x.id === JSON.parse(this.ruta.dato).id_tipo_periodo);
            this.PeriodoSeleccionado = this.catTipoperiodo[0];
        }else 
        {
            this.catTipoperiodo = datoRetorno.filter(x => x.descripcion != "ANUAL" && x.descripcion != "SEMESTRAL");
            this.catTipoperiodo.unshift({ numRow: null, id: null, descripcion: 'SELECCIONA...', baja: false, cambio: false });
        }
        
    }

    async buscaAnio(zona: CatRutas) {
        try {
            await this.getTipoPeriodo();
        this.catVencimientosLecturasInputAnio = new CatVencimientosInput();
        if (!zona) return;
        if (zona) {
            this.catVencimientosLecturasInputAnio._zona = zona.id.toString();
        }
        var today = new Date();
        var year = today.getFullYear();
        
        const datoRetorno = await this.vencimientosLecturaService.getBusquedas(this.catVencimientosLecturasInputAnio).toPromise();
        // Extrae los años
        var anios = datoRetorno.map(function(item) {
            return item.anio;
        });
        
        var aniosUnicos = anios.filter(function(value, index, self) {
            return self.indexOf(value) === index;
        }).map(function(value) {
            return { anio: value };  // Convierte cada año en un objeto con la propiedad "anio"
        });
        
        console.log(aniosUnicos);
        if (this.MustraPeriodoActual) {
            this.anios = datoRetorno;
            this.anios = [];
            this.anios.unshift({ numRow: null, anio: year.toString(), periodo: '0' });
            this.anios.unshift({ numRow: null, anio: 'SELECCIONA...', periodo: null });
        } else {
            this.anios = aniosUnicos;
            this.anios.unshift({ numRow: null, anio: 'SELECCIONA...'});

        }
        this.buscaPeriodo();
        this.buscaProximaAsignacion(zona.id);
        } catch (error) {
            throw error;

        }
        
    }
    async buscaProximaAsignacion(idAguaZona: number)
    {
        try {
            this.proximaasignacion = new ProximaAsignacionInput();
            this.proximaasignacion.idAguaZona = idAguaZona;
            this.proximaasignacion.actual = this.currentRoute !== 'genera-rutas' ? true : false;
             

            const datoRetorno = await this.proximaAsignacionService.postOperaciones(this.proximaasignacion).toPromise();
            if(datoRetorno){
                this.anioSeleccionado = this.anios.find(x=>x.anio === datoRetorno[0].anio.toString());   

                await this.buscaPeriodo() ;
                console.log("this.bimestre this.bimestre",this.bimestre);
                
                if(this.bimestre)
                    this.bimestreSeleccionado = this.bimestre.find(x=>x.periodo === datoRetorno[0].periodoParcialidad.toString())
               
            }
            console.log("datoRetorno", datoRetorno)
        } catch (error) {

            throw error;
        }

    }

    async buscaPeriodo() {
        console.log("this.anioSeleccionado ",this.anioSeleccionado,    );

        if (!this.anioSeleccionado?.anio) return;
        console.log("this.ruta ",this.ruta, );  
        if (!this.ruta?.id) return;
        console.log(  "this.PeriodoSeleccionado ",this.PeriodoSeleccionado, );
        if (!this.PeriodoSeleccionado?.id) return;

        var today = new Date();
        var mes = today.getMonth() + 1;
        var periodo = this.correccionBimestres(mes.toString());

        this.bimestre = [];

        this.catVencimientosLecturasInputPeriodo = new CatVencimientosInput();
      
        this.catVencimientosLecturasInputPeriodo._anio = this.anioSeleccionado.anio;
        this.catVencimientosLecturasInputPeriodo._zona = this.ruta.id.toString();
        this.catVencimientosLecturasInputPeriodo._idPeriodo = this.PeriodoSeleccionado.id;
        console.log("this.catVencimientosLecturasInputPeriodo",this.catVencimientosLecturasInputPeriodo);
        
        const datoRetorno = await this.vencimientosLecturaService.getBusquedas(this.catVencimientosLecturasInputPeriodo).toPromise();
        if (!datoRetorno) return;

        if (this.MustraPeriodoActual) {
            this.bimestre = datoRetorno;
            this.bimestre = [];
            this.bimestre.unshift({ numRow: null, anio: null, periodo: periodo.toString() });
            this.bimestre.unshift({ numRow: null, anio: null, periodo: 'SELECCIONA...' });
        } else {
            this.bimestre = datoRetorno;
            this.bimestre.unshift({ numRow: null, anio: null, periodo: 'SELECCIONA...' });
        }

    }

    async getCatUsuarios() {
        try {
            this.usuarios = new ObtenerUsuarioPorCargoInput;

            this.usuarios.idCargo = 1;
            this.usuarios.idEstatus = 1;

            let datoRetorno = await this.catUsuariosService.getBusquedas(this.usuarios).toPromise();
            this.catUsuarios = datoRetorno;
            this.catUsuarios.unshift({ id: null, nombre: 'SELECCIONA...', nombreUsuario: 'SELECCIONA...', cargo: null, departamento: null, direccion: null, idSucursal: null });
           
            //SE ASIGNA EL USUARIO AL COMBO DE CAJEROS
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getCatUsuarios");
        }
    }

    async getCatColonias() {
        const datoRetorno = await this.CatColoniasService.getAll().toPromise();
        this.catColonias = datoRetorno;
        this.catColonias.unshift({ numRow: null, baja: null, cambio: null, id: null, descripcion: 'SELECCIONA...', idZona: null,idDelagacion : null });
 
    }

    async buscaCuenta() {

        this.aguasOutput.emit(null);
        this.aguaBuscaCuentas.emit(null);
        //this.consultaLectura.cuenta = this.cuenta;
        this.consultaLectura.ruta = null;
        this.consultaLectura.anioIn = null;
        this.consultaLectura.periodo = null;
        this.consultaLectura.lecturista = null;
        this.consultaLectura.colonia = null;

        let buscaAgua = new AguaBuscaCuentasInput;
        buscaAgua.cuentaAgua = parseInt(this.cuenta);

        this.datosAguaCuenta.cuentaAgua = parseInt(this.consultaLectura.idAgua);
        if (this.datosAguaCuenta.cuentaAgua == null) {
            this.muestraMensaje.error('Ingresa una cuenta para la busqueda', 'top', 'center'); return
        }
      
        const datoretorno = await this.aguaBuscaCuentasService
            .add(buscaAgua)
            .toPromise();

      
        if (Object.keys(datoretorno).length == 1) {
            if (this.esEstadoCuentaMaisvo){
             
                if(this.catRutas){
                    this.ruta = this.catRutas.find(x=>x.descripcion == datoretorno[0].idRuta);
                    this.PeriodoSeleccionado = this.catTipoperiodo.find(x=> x.id == datoretorno[0].idTipoPeriodo)
                    this.buscaAnio(this.ruta) 
                    return;
                }

            }else{

                this.consultaLectura.idAgua = datoretorno[0].id.toString();;
                this.busquedaParametrosInput.emit(this.consultaLectura);
            }
            
        } else if (Object.keys(datoretorno).length >= 2) {

            this.aguaBuscaCuentas.emit(null);
            this.aguaBuscaCuentas.emit(datoretorno);
            $("#exampleModalLong").modal();

        } else {
            this.muestraMensaje.error("No se encontró registro.", "top", "center");
        }
        this.progressBar1 = false;
        this.Actualizar();
    }

   async imprimeResibos(){

        this.showBar();
        this.consultaLectura = new ConsultaLecturasInput();

        if(this.validacionInput()){
            //volvemo actualizar fechas ya que puede ser que no se impriman al generar calculo    
            this.calculoCargosAguasInput = new CalculoCargosAguasInput();
            this.calculoCargosAguasInput.idRuta = this.consultaLectura.ruta;
            this.calculoCargosAguasInput.fechaEmision = this.consultaLectura.fechafac;
            this.calculoCargosAguasInput.fechaFacturacion = this.consultaLectura.fechaemisi;
            this.calculoCargosAguasInput.fechaVencimiento = this.consultaLectura.fechavence;
            this.calculoCargosAguasInput.periodo = this.consultaLectura.periodo;
            this.calculoCargosAguasInput.anio = this.consultaLectura.anioIn;
            this.calculoCargosAguasInput.conEstimadoAnual = true // usamos esta variable para saber que se actualiza fechas por proceso de imprimir recibos
            
            if(!this.checkedReimprimir){
                //primero mandamos mensaje de confirmacion de impresion
                this.confirmationService.confirm({
                    header: 'Confirmación',
                    message: `¿Está seguro que desea imprimir los recibos?
                    <br>Ruta: <strong>${this.consultaLectura.rutaDesc}</strong> Año: <strong>${this.consultaLectura.anioIn}</strong> Periodo: <strong>${this.consultaLectura.periodo}</strong>`,
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                        await this.calculoCargosAguasService.getActualiza(this.calculoCargosAguasInput).toPromise();
                        this.consultaLectura._reimpresion_recibo = false;
                        this.ImprimeRecibosEmit.emit(this.consultaLectura);
                    },
                    reject: () => {
                    return
                    },
                    key: 'positionDialog',
                });
            }else{

                this.confirmationService.confirm({
                    header: 'Confirmación',
                    message: `¿Está seguro que desea <strong>Reimprimir</strong> los recibos?
                    <br>Ruta: <strong>${this.consultaLectura.rutaDesc}</strong> Año: <strong>${this.consultaLectura.anioIn}</strong> Periodo: <strong>${this.consultaLectura.periodo}</strong>`,
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                        this.consultaLectura._reimpresion_recibo = true;
                        this.ImprimeRecibosEmit.emit(this.consultaLectura);
                    },
                    reject: () => {
                    return
                    },
                    key: 'positionDialog',
                });
            }
        };
   };

   async imprimirRecepcion(){
        try {

            this.showBar();
            this.consultaLectura = new ConsultaLecturasInput();

            if(this.cuenta != null || this.ruta != null ){

                if(this.cuenta != null && this.cuenta != "" )
                {
                    this.consultaLectura.cuentaAgua = Number(this.cuenta)
                    this.consultaLectura.ruta = null 
                    this.consultaLectura.rutaDesc = null 

                    throw new Error("Solo imprime hoja de recepción por rutas");

                }else{

                    if (this.ruta != null) {
                        this.consultaLectura.ruta = this.ruta.id;
                        this.consultaLectura.rutaDesc = this.ruta.descripcion;
                    } else {
                        throw new Error("Debe seleccionar una Ruta.");
                    };
        
                };

                if (this.anioSeleccionado != null) {
                  
                    this.consultaLectura.anioIn = parseInt(this.anioSeleccionado.anio);
                } else {
                    throw new Error("Debe seleccionar una Año.");
                };

                if (this.bimestreSeleccionado != null) {
                    this.consultaLectura.periodo = parseInt(this.bimestreSeleccionado.periodo);
                } else {
                 
                    throw new Error("Debe seleccionar un Bimestre.");
                };

            }else{
                throw new Error("Debe indicar una cuenta o ruta");
            }
            
            this.ImprimeRecepcionEmit.emit(this.consultaLectura);
            
        } catch (e) {
            this.muestraMensaje.error(e, "top", "center");
            this.progressBar1 = false;
        };
   };

    async buscar(event, flagRecalcular: boolean = false) {
        this.showBar();       
        this.consultaLectura = new ConsultaLecturasInput();
        try {
            if (this.ruta != null || this.cuenta != null) {

                if (this.cuenta != null && event.currentTarget.id != "btnCalcular") {
                    this.buscaCuenta();
                } else {
                    if(this.validacionInput()) {
                        this.busquedaParametrosInput.emit(this.consultaLectura );
                        this.flagRecalcular.emit(flagRecalcular);
                        this.disabledImpRecibos = this.checkedReimprimir ? false : true;
                    }
                }
 
                // this.Actualizar();
            } else {
                throw new Error("Debe seleccionar un Criterio de Búsqueda.");
            }
        } catch (e) {
            this.muestraMensaje.error(e, "top", "center");
            console.log(e.message);
            this.progressBar1 = false;
        }
    };

    validacionInput(){

        try {
            if(this.cuenta == null){
                if (this.ruta != null) {
                    this.consultaLectura.ruta = this.ruta.id; 
                    this.consultaLectura.rutaDesc = this.ruta.descripcion;
                    
                } else {
                    throw new Error("Debe seleccionar una Ruta.");
                };
        
            }else{
                this.consultaLectura.ruta = null
                this.consultaLectura.cuentaAgua = Number(this.cuenta)
            }

            if (this.anioSeleccionado != null) {
                this.consultaLectura.anioIn = parseInt(this.anioSeleccionado.anio);
            } else {
                throw new Error("Debe seleccionar una Año.");
            };
    
            if (this.bimestreSeleccionado != null) {
                this.consultaLectura.periodo = parseInt(this.bimestreSeleccionado.periodo);
            } else {
                throw new Error("Debe seleccionar un Mes o periodo.");
            };
           
            if (this.usuarioSeleccionado) {
                this.consultaLectura.lecturista = this.usuarioSeleccionado.id;
            };
    
            if (this.fechafac == this.fechavence) {
                throw new Error("La fecha de vencimiento no puede ser igual a la fecha de facturacion");
            };
    
            if (this.fechafac > this.fechavence) {
                throw new Error("La fecha de facturacion no puede ser mayor a la fecha de vencimiento");
            };
          
            this.consultaLectura.fechafac   = this.fechafac;
            this.consultaLectura.fechavence = this.fechavence;
            this.consultaLectura.fechaemisi = this.fechaemisi;
            this.consultaLectura.colonia    = null;
            this.consultaLectura.avisoDirec = this.avisoDirectivo;

            return true

        } catch (e) {
            this.muestraMensaje.error(e, "top", "center");
            console.log(e.message);
            this.progressBar1 = false;
            return false
        }

        
    };

    changecheckbox() {
       // console.log(this.avisoDirectivo)
    }

    changecheckboxObservacion(){
        //console.log(this.observacionesMasivasCheckbox)
    }

    onKeydown(event) {
        if (event.key === "Enter") {
            this.buscar(event);
        }
    }

    async Actualizar() {
        this.consultaLectura = new ConsultaLecturasInput();
        this.consultaLectura.ruta = null;
        this.consultaLectura.anioIn = null;
        this.consultaLectura.periodo = null;
        this.consultaLectura.lecturista = null;

        this.usuarioSeleccionado = null;
        this.coloniaSeleccionado = null;
        this.anioSeleccionado = null;
        this.bimestreSeleccionado = null;
        this.cuenta = null;
        this.ruta = null;
        this.progressBar1 = false;
    }
    async childAguaBuscaCuentasGrid(aguas: Aguas) {
        $("#exampleModalLong").modal('hide');
        if (!aguas) {
            this.aguasOutput.emit(null);
            return;
        }
        this.aguasOutput.emit(null);
        this.aguasOutput.emit(aguas);

        this.consultaLectura.ruta = null;
        this.consultaLectura.anioIn = null;
        this.consultaLectura.periodo = null;
        this.consultaLectura.lecturista = null;
        this.consultaLectura.colonia = null;

        this.consultaLectura.idAgua = aguas.id.toString();;

        this.busquedaParametrosInput.emit(this.consultaLectura);
    }


    async limpiar() {
        this.progressBar1 = false;
        this.eliminaProgressBar.emit(false);
        //await this.busquedaParametrosInput.emit(null);
        // this.anios = null;
        // this.bimestre = null;
        this.consultaLectura = new ConsultaLecturasInput();
        this.consultaLectura.ruta = null;
        this.consultaLectura.anioIn = null;
        this.consultaLectura.periodo = null;
        this.consultaLectura.lecturista = null;
        this.busquedaParametrosInput.emit(this.consultaLectura);
        //this.catUsuarios = [{id: null, nombre: 'SELECCIONA...', nombreUsuario:'SELECCIONA...', cargo : null, departamento:null, direccion:null}];
        this.usuarioSeleccionado = null;
        this.coloniaSeleccionado = null;
        this.anioSeleccionado = null;
        this.PeriodoSeleccionado = null;
        this.bimestreSeleccionado = null;
        this.cuenta = null;
        this.ruta = null;
        // await this.getCatRutas();
        // await this.getCatUsuarios();
        this.imprime = true;
        this.disabledCalcula = true;
        this.disabledImpRecibos = true;
        this.disabledImpRecepcion = true;
        
        if(!this.clickReimprimir){
            this.checkedReimprimir = false;
            this.emiteDesabledBotton.emit(this.checkedReimprimir);
            this.cerrarRutaEmit.emit(false);
            await this.getCatRutas();
        }

    
    }
    correccionBimestres(bimestreNumero: string) {
        console.log("bimestreNumero",bimestreNumero);
        
        switch (bimestreNumero) {
            case "1":
                return "1";
                break;
            case "2":
                return "1";
                break;
            case "3":
                return "2";
                break;
            case "4":
                return "2";
                break;
            case "5":
                return "3";
                break;
            case "6":
                return "3";
                break;
            case "7":
                return "4";
                break;
            case "8":
                return "4";
                break;
            case "9":
                return "5";
                break;
            case "10":
                return "5";
                break;
            case "11":
                return "6";
                break;
            case "12":
                return "6";
                break;
            default:
                break;
        }
    }

    async calcular(event) {
        try {
            this.calculoCargosAguasInput = new CalculoCargosAguasInput();
            await this.buscar(event, true);
 
            this.calculoCargosAguasInput.idRuta = this.consultaLectura.ruta;
            this.calculoCargosAguasInput.fechaEmision = this.consultaLectura.fechafac;
            this.calculoCargosAguasInput.fechaFacturacion = this.consultaLectura.fechaemisi;
            this.calculoCargosAguasInput.fechaVencimiento = this.consultaLectura.fechavence;
            this.calculoCargosAguasInput.periodo = this.consultaLectura.periodo;
            this.calculoCargosAguasInput.anio = this.consultaLectura.anioIn;
            this.calculoCargosAguasInput.conEstimadoAnual = false; // usamos esta variable para saber que se actualiza fechas por proceso de calculo
           
            await this.calculoCargosAguasService.getActualiza(this.calculoCargosAguasInput).toPromise();
            this.calculoCargosAguasInput.conEstimadoAnual = null;  // omitimos ya no es necesario para el calculo
            await this.emitirCalculoLectura(this.consultaLectura);
            await this.calcularOutput.emit(this.consultaLectura);
    
            this.imprime = false;
            this.disabledImpRecibos = false;
             
        } catch (e) {
            //his.muestraMensaje.error(e, "top", "center");
           throw e;
            this.progressBar1 = false;
        } finally {
            console.log("Paso por calcular");
        }
    } 
    // se crea promesa para emitir evento en el boton calcular
    async emitirCalculoLectura(consultaLectura: ConsultaLecturasInput): Promise<void> {
        return new Promise((resolve) => {
          const evento: EventoCalculoLectura = { consultaLectura, resolve };
          this.calcularOutput.emit(evento.consultaLectura);
        });
      }
      
      

    async cerrarRuta (){
    this.cerrarRutaEmit.emit(true);
    }
    async abreDomiciliacion() {
        try {
            this.domiciliacion$.emit(true);
            this.displayDomiciliacion = true;
        } catch (e) {
          this.muestraMensaje.error(e , "top", "center");
        }finally{
          console.log("Paso por abreDomiciliacion");
        }
      }

      async borraFiltros() {
        await this.getCatRutas();
        this.catTipoperiodo = this.anios = this.bimestre = [];
        this.anioSeleccionado = this.bimestreSeleccionado = null;
      }

      showValLecturas(){
        this.vallecturas = true;
      }

  async imprimirLecCalculadas() {
    try {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "LecturasCalculadas";
        this.auxJasper.JasperReport.tipo = "pdf";
    
        let _id_zonas_agua = new ParametroJasper();
        _id_zonas_agua.nombre = "_id_agua_zona";
        _id_zonas_agua.valor = this.ruta.id + "";
        this.auxJasper.ParametroJasper.push(_id_zonas_agua);

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.anioSeleccionado.anio + "";
        this.auxJasper.ParametroJasper.push(_anio);

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.bimestreSeleccionado.periodo + "";
        this.auxJasper.ParametroJasper.push(_periodo_parcialidad);

        this.display=true;
        this.showValLecturas();
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirLecturasCalculadas");
        this.progressBar = false;
    }
}

async imprimirLecValidadas() {
    try {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "LecturasValidadas";
        this.auxJasper.JasperReport.tipo = "pdf";
    
        let _id_zonas_agua = new ParametroJasper();
        _id_zonas_agua.nombre = "_id_agua_zona";
        _id_zonas_agua.valor = this.ruta.id + "";
        this.auxJasper.ParametroJasper.push(_id_zonas_agua);

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.anioSeleccionado.anio + "";
        this.auxJasper.ParametroJasper.push(_anio);

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.bimestreSeleccionado.periodo + "";
        this.auxJasper.ParametroJasper.push(_periodo_parcialidad);

        this.display=true;
        this.showValLecturas();
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirLecturasValidadas");
        this.progressBar = false;
    }
}
 
async imprimirFacDetallada() {
    try {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "FacturacionDetallada";
        this.auxJasper.JasperReport.tipo = "pdf";
    
        let _id_zonas_agua = new ParametroJasper();
        _id_zonas_agua.nombre = "_id_agua_zona";
        _id_zonas_agua.valor = this.ruta.id + "";
        this.auxJasper.ParametroJasper.push(_id_zonas_agua);

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.anioSeleccionado.anio + "";
        this.auxJasper.ParametroJasper.push(_anio);

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.bimestreSeleccionado.periodo + "";
        this.auxJasper.ParametroJasper.push(_periodo_parcialidad);

        this.display=true;
        this.showValLecturas();
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirFacturacionDetallada");
        this.progressBar = false;
    }
}    
async imprimirResFacturacion() {
    try {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "ResumenFacturacion";
        this.auxJasper.JasperReport.tipo = "pdf";
    
        let _id_zonas_agua = new ParametroJasper();
        _id_zonas_agua.nombre = "_id_agua_zona";
        _id_zonas_agua.valor = this.ruta.id + "";
        this.auxJasper.ParametroJasper.push(_id_zonas_agua);

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.anioSeleccionado.anio + "";
        this.auxJasper.ParametroJasper.push(_anio);

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.bimestreSeleccionado.periodo + "";
        this.auxJasper.ParametroJasper.push(_periodo_parcialidad);

        this.display=true;
        this.showValLecturas();
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirResumenFacturacion");
        this.progressBar = false;
    }
}    

async imprimirRutasDetallada() {
    try {
        if( !this.anio || !this.periodo ){
            this.muestraMensaje.error('Ingresa un Año y un Periodo para generar el reporte', 'top', 'center'); 
            return;
        }
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "019_Detalles_rutas";
        this.auxJasper.JasperReport.tipo = "pdf";

        let _anio = new ParametroJasper();
        _anio.nombre = "_anio";
        _anio.valor = this.anio + "";
        this.auxJasper.ParametroJasper.push(_anio);

        let _periodo_parcialidad = new ParametroJasper();
        _periodo_parcialidad.nombre = "_periodo_parcialidad";
        _periodo_parcialidad.valor = this.periodo + "";
        this.auxJasper.ParametroJasper.push(_periodo_parcialidad);

        this.display=true;       
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirRutasDetallada");
        this.progressBar = false;
    }
}

normalizarFecha(fecha: Date): Date {
    const date = new Date(fecha);
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
}

async cambiaReimprimir(event: any) {
    this.clickReimprimir = true;
    this.checkedReimprimir = event.checked;
    this.limpiar();
    
    if(event.checked){
        this.msjTooltip = "Reimprimir recibos"
        this.emiteDesabledBotton.emit(true);
        this.cerrarRutaEmit.emit(true);
    }else{
        this.msjTooltip = "Imprimir recibos"
        this.emiteDesabledBotton.emit(false);
        this.cerrarRutaEmit.emit(false);
    }
    
    try {
        this.emiteProgressBar.emit(true);
        await this.getCatRutas();
        this.emiteProgressBar.emit(false);
    } catch (error) {
        
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
    }
    this.clickReimprimir = false;
}

 async getPrivilegios() {
      try {
        let objUrl = new Privilegios();
        objUrl.uuid = 'f508fe55-92ae-4379-b956-245838af8cca';
        let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
        return conPrivilegio;
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      }
  }
 
}export interface EventoCalculoLectura {
    consultaLectura: ConsultaLecturasInput;
    resolve: () => void;
  }


